export const sectionExperiments = {
  headerSectionAddVisibilityTransition:
    'specs.thunderbolt.HeaderSectionAddVisibilityTransition',
};
